import * as React from 'react';
import { NavLink } from 'reactstrap';
import { hasSegments } from '~/lib/helper/RouteHelper';

type RouteDef = {
    name: string;
    path: string;
    icon: string;
    isActive?: (url: string) => boolean;
};

const servicesSegments = [
    '/services',
    '/server',
    '/network',
    '/add-server',
    '/add-network',
    '/add-loadbalancer',
    '/loadbalancer',
];
const domainSegments = ['/domains', '/add-domain-hosting', '/domain'];
const billingSegments = ['/billing', '/invoices', '/payments', '/credits'];
const accountSegments = ['/account', '/ssh-keys'];

// These nav rows are mirrored by the pre-mount skeleton in
// Views/Shared/PanelPage.cshtml — keep both in sync.
const Routes: RouteDef[] = [
    {
        name: 'Services',
        path: '/services',
        icon: 'ion-md-desktop',
        isActive: (url) => hasSegments(url, servicesSegments),
    },
    {
        name: 'Domains',
        path: '/domains',
        icon: 'ion-md-globe',
        isActive: (url) => hasSegments(url, domainSegments),
    },
    {
        name: 'Billing',
        path: '/billing',
        icon: 'ion-md-card',
        isActive: (url) => hasSegments(url, billingSegments),
    },
    {
        name: 'Account',
        path: '/account',
        icon: 'ion-md-person',
        isActive: (url) => hasSegments(url, accountSegments),
    },
    {
        name: 'Developer API',
        path: '/api-info',
        icon: 'ion-md-code',
        isActive: (url) => hasSegments(url, ['/api-info']),
    },
];

type MainNavigationProps = {
    location: Location;
    currentUserEmail?: string;
};

export function MainNavigation({ location, currentUserEmail }: MainNavigationProps) {
    // verifies if route is the one active (in browser input)
    const activeRoute = (route: RouteDef) => {
        if (!route.isActive) return '';
        return route.isActive(location.pathname) ? 'active' : '';
    };

    return (
        <ul className="nav">
            {Routes.map((prop, key) => {
                return (
                    <li className={activeRoute(prop)} key={key}>
                        <NavLink
                            href={prop.path}
                            className="nav-link"
                            title={prop.name === 'Account' ? `Account: ${currentUserEmail ?? ''}` : prop.name}
                        >
                            <i className={'icon ' + prop.icon} />
                            <span className="label">{prop.name}</span>
                        </NavLink>
                    </li>
                );
            })}
        </ul>
    );
}
